import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BAUMISCH from '../assets/images/icons/Baumisch.png';
import BAUSCHUTT from '../assets/images/icons/Bauschutt.png';
import { default as SONSTIGEABFAELLE } from '../assets/images/icons/Gemischte Abfaelle.png';
import GRUENSCHNITT from '../assets/images/icons/Gruenschnitt.png';
import HOLZ from '../assets/images/icons/Holz.png';
import METALL from '../assets/images/icons/Metall.png';
import Logo from '../assets/images/Logo_HIRSCH.png';
import MitarbeiterHirsch1 from '../assets/images/MitarbeiterHirsch1.jpg';
import MitarbeiterHirsch2 from '../assets/images/MitarbeiterHirsch2.jpg';
import MitarbeiterHirsch3 from '../assets/images/MitarbeiterHirsch3.jpg';
import ContainerBooking from './ContainerBooking';


export default function HomePage() {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const bookingResetTrigger = location.state?.resetBooking ? String(location.key || Date.now()) : "";
    // const [pageData, setPageData] = useState(null);

    useEffect(() => {
        if (!location.state?.scrollToWasteTypes) return;

        const timeoutId = setTimeout(() => {
            const element = document.getElementById('abfallarten');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);

        return () => clearTimeout(timeoutId);
    }, [location.state]);

    const teamMembers = [
        {
            image: MitarbeiterHirsch1,
            alt: 'Sachbearbeiter 1',
            zoomClass: 'scale-[1.34]',
            positionClass: 'object-[center_28%]'
        },
        {
            image: MitarbeiterHirsch2,
            alt: 'Sachbearbeiter 2',
            zoomClass: 'scale-[1.32]',
            positionClass: 'object-[center_26%]'
        },
        {
            image: MitarbeiterHirsch3,
            alt: 'Sachbearbeiter 3',
            zoomClass: 'scale-[1.17]',
            positionClass: 'object-[center_18%]'
        }
    ];


    // useEffect(() => {
    //     async function getPage() {
    //         const res = await fetch(
    //             "https://cms.operintell.de/wp-json/wp/v2/pages?slug=hirsch-test",
    //             { next: { revalidate: 60 } }
    //         );
    //         const pages = await res.json();
    //         return pages[0];
    //     }
    //     getPage().then((page) => {
    //         console.log("Fetched page:", page);
    //         setPageData(page);
    //     });
    // }, []);

    // if (!pageData) return <div>Loading...</div>;

    return (
        <div className="min-h-screen">
            {/* Header Navigation */}
            <header className="bg-white shadow-sm sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-32">
                        {/* Logo */}
                        <div className="flex items-center">
                            <Link to="/" state={{ resetBooking: true }} replace className="flex items-center">
                                <img src={Logo} alt="Hirsch Logo" className="h-12 lg:h-24" />
                            </Link>
                        </div>

                        {/* Desktop Navigation */}
                        <nav className="hidden  lg:flex items-center space-x-8">
                            <div className="relative group">
                                <button className="text-gray-600 hover:text-gray-900 font-medium text-xl flex items-center gap-1">
                                    <a href='#hero'>Jetzt buchen!</a>
                                </button>
                            </div>
                            <div className="relative group">
                                <button className="text-gray-600 hover:text-gray-900 font-medium text-xl flex items-center gap-1">
                                    <a href='#abfallarten'>Abfallarten</a>

                                </button>
                            </div>
                            <div className="relative group">
                                <button className="text-gray-600 hover:text-gray-900 font-medium text-xl flex items-center gap-1">
                                    <a href='#container'>Container</a>
                                </button>
                            </div>
                            <div className="relative group">
                                <button className="text-gray-600 hover:text-gray-900 font-medium text-xl flex items-center gap-1">
                                    <a href='#faq'>Kontakt</a>
                                </button>
                            </div>
                            <Link
                                to="/cart"
                                className="bg-pink-600 text-white px-6 py-2.5 rounded-md hover:bg-pink-700 transition-colors font-bold text-sm uppercase"
                            >
                                Warenkorb
                            </Link>
                        </nav>

                        {/* Mobile menu button */}
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="lg:hidden text-gray-600 hover:text-gray-900 p-2 rounded-lg hover:bg-gray-100 transition-all"
                            aria-label="Toggle menu"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>

                    {/* Mobile Navigation */}
                    {isMenuOpen && (
                        <div className="lg:hidden py-4 border-t border-gray-100">
                            <nav className="flex flex-col space-y-2">
                                <a href="#hero" onClick={() => setIsMenuOpen(false)} className="text-gray-600 hover:text-gray-900 hover:bg-gray-50 font-medium py-3 px-3 rounded-lg transition-all">
                                    Jetzt buchen!
                                </a>
                                <a href="#abfallarten" onClick={() => setIsMenuOpen(false)} className="text-gray-600 hover:text-gray-900 hover:bg-gray-50 font-medium py-3 px-3 rounded-lg transition-all">
                                    Abfallarten
                                </a>
                                <a href="#container" onClick={() => setIsMenuOpen(false)} className="text-gray-600 hover:text-gray-900 hover:bg-gray-50 font-medium py-3 px-3 rounded-lg transition-all">
                                    Container
                                </a>
                                <a href="#faq" onClick={() => setIsMenuOpen(false)} className="text-gray-600 hover:text-gray-900 hover:bg-gray-50 font-medium py-3 px-3 rounded-lg transition-all">
                                    Kontakt
                                </a>
                                <Link to="/cart" className="bg-pink-600 text-white px-4 py-3 rounded-md hover:bg-pink-700 transition-colors font-bold inline-block text-center mt-2 uppercase">
                                    SHOP
                                </Link>
                            </nav>
                        </div>
                    )}
                </div>
            </header>

            {/* Hero Section - Container Booking */}
            <section id="hero" style={{ background: 'transparent' }}>
                <ContainerBooking resetTrigger={bookingResetTrigger} />
            </section>

            {/* Professionelle Entsorgung Section */}
            <section id="about" className="py-12 sm:py-16 lg:py-24 bg-white">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-12 lg:mb-16">
                            <h2 className="text-2xl sm:text-3xl lg:text-5xl xl:text-6xl font-bold text-pink-500 mb-4 lg:mb-6 leading-tight">
                                Professionelle Entsorgung für Bau- und Gartenabfälle.
                            </h2>
                            <h3 className="text-lg sm:text-xl lg:text-3xl xl:text-4xl font-bold text-pink-500 mb-6 lg:mb-8">
                                Schnell, zuverlässig und umweltfreundlich seit 1966.
                            </h3>
                            <p className="text-base sm:text-lg lg:text-xl xl:text-2xl text-gray-600 max-w-5xl mx-auto mb-6 lg:mb-8 leading-relaxed">
                                Im HIRSCH Onlineshop finden Sie schnell und unkompliziert den passenden Container für Ihre Abfälle. Ob Sperrmüll, Bauschutt oder Grünschnitt - wir machen die Containerbestellung für Sie einfach und transparent.
                            </p>

                            <div className='bg-pink-300 text-pink-700 text-sm sm:text-base lg:text-lg xl:text-xl inline-block rounded-xl px-6 py-4 lg:px-8 lg:py-6 mt-4 lg:mt-6 shadow-lg max-w-4xl'>
                                Alle Container stehen Ihnen <b>7 Tage mietfrei</b> zur Verfügung. Sie zahlen lediglich die Entsorgungskosten!
                            </div>
                        </div>

                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-8 lg:mt-12">
                            {/* Feature 1 */}
                            <div className="text-center bg-pink-100 p-6 lg:p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
                                <div className="bg-pink-200 w-16 h-16 lg:w-20 lg:h-20 rounded-full flex items-center justify-center mx-auto mb-4 lg:mb-6">
                                    <svg className="w-8 h-8 lg:w-10 lg:h-10 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <h3 className="text-lg lg:text-xl font-bold text-gray-900 mb-3">Schnelle Lieferung</h3>
                                <p className="text-sm lg:text-base text-gray-600 leading-relaxed">
                                    Container werden binnen 48 Stunden geliefert und termingerecht abgeholt.
                                </p>
                            </div>

                            {/* Feature 2 */}
                            <div className="text-center bg-pink-100 p-6 lg:p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
                                <div className="bg-pink-200 w-16 h-16 lg:w-20 lg:h-20 rounded-full flex items-center justify-center mx-auto mb-4 lg:mb-6">
                                    <svg className="w-8 h-8 lg:w-10 lg:h-10 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <h3 className="text-lg lg:text-xl font-bold text-gray-900 mb-3">Umweltfreundlich</h3>
                                <p className="text-sm lg:text-base text-gray-600 leading-relaxed">
                                    Fachgerechte Entsorgung und Recycling nach höchsten Umweltstandards
                                </p>
                            </div>

                            {/* Feature 3 */}
                            <div className="text-center bg-pink-100 p-6 lg:p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 sm:col-span-2 lg:col-span-1">
                                <div className="bg-pink-200 w-16 h-16 lg:w-20 lg:h-20 rounded-full flex items-center justify-center mx-auto mb-4 lg:mb-6">
                                    <svg className="w-8 h-8 lg:w-10 lg:h-10 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c-1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                    </svg>
                                </div>
                                <h3 className="text-lg lg:text-xl font-bold text-gray-900 mb-3">Faire Preise</h3>
                                <p className="text-sm lg:text-base text-gray-600 leading-relaxed">
                                    Transparente Preisgestaltung ohne versteckte Kosten. Vorsortierung spart Geld!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Abfallarten */}
            <section id="abfallarten" className="py-12 sm:py-16 lg:py-24 bg-gray-50">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-10 lg:mb-16">
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-pink-500 mb-4">Unsere Abfallarten</h2>
                        <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">Professionelle Entsorgung für jeden Bedarf</p>
                    </div>
                    <div className='grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-6xl mx-auto'>
                        {/* Flip Box 1 */}
                        <Link to="/wastetype/baumisch-abfall" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={BAUMISCH} alt="Baumisch-Abfall" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            BAUMISCH-ABFALL
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Gemischte Abfälle aus Bau- und Renovierungsarbeiten, die nicht sortenrein getrennt werden können. Ideal für kleinere Bauprojekte.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        {/* Flip Box 2 */}
                        <Link to="/wastetype/bauschutt" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={BAUSCHUTT} alt="Bauschutt" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            BAUSCHUTT
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Mineralische Abfälle wie Beton, Ziegel, Fliesen und Mörtel. Ideal für Abriss- und Renovierungsarbeiten.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        {/* Flip Box 3 */}
                        {/* <Link to="/wastetype/sperrmuell" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={SPERRMUELL} alt="Sperrmüll" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            SPERRMÜLL
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Alte Möbel, Matratzen, Teppiche und andere sperrige Haushaltsgegenstände, die nicht in die normale Mülltonne passen.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link> */}

                        {/* Flip Box 4 */}
                        <Link to="/wastetype/gruenschnitt" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={GRUENSCHNITT} alt="Grünschnitt" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            GRÜNSCHNITT
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Gartenabfälle wie Äste, Zweige, Laub, Rasenschnitt und Pflanzenreste. Perfekt für die Gartenarbeit.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        {/* Flip Box 5 */}
                        <Link to="/wastetype/holz" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={HOLZ} alt="Holz" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            HOLZ
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Unbehandeltes und behandeltes Holz, Holzbalken, Bretter, Paletten und andere Holzabfälle aus Bau und Haushalt.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link>



                        {/* Flip Box 6 */}
                        {/* <Link to="/wastetype/papier-pappe" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={PAPIERUNDPAPPE} alt="Papier & Pappe" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            PAPIER & PAPPE
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Kartonagen, Papier, Zeitungen und andere Papiererzeugnisse. Wichtig für das Recycling und die Umwelt.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link> */}

                        {/* Flip Box 7 */}
                        <Link to="/wastetype/metall" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={METALL} alt="Metall" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            METALL
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Altmetalle wie Eisen, Stahl, Aluminium, Kupfer und andere metallische Abfälle. Wertstoff mit hoher Recyclingquote.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        {/* Flip Box 6 */}
                        <Link to="/wastetype/sonstige-abfaelle" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={SONSTIGEABFAELLE} alt="Sonstige Abfälle" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            Sonstige Abfälle
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Verschiedene nicht sortierte Abfälle aus Haushalt und Gewerbe, die keiner speziellen Kategorie zugeordnet werden können.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        {/* Flip Box 8 */}
                        {/* <Link to="/wastetype/boden-steine" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={BODENUNDSTEINE} alt="Boden & Steine" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            BODEN & STEINE
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Unbelasteter Erdaushub, Steine, Sand und Kies. Ideal für Garten- und Landschaftsbauarbeiten.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link> */}

                        {/* Flip Box 9 */}
                        {/* <Link to="/wastetype/gemischte-abfaelle" className="flip-card h-64 hover:shadow-xl transition-shadow duration-300 block">
                            <div className="flip-card-inner">
                                <div className="flip-card-front bg-pink-200 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4"><img src={GEMISCHTEABFAELLE} alt="Gemischte Abfälle" className="w-16 h-16 sm:w-20 sm:h-20 mb-2 sm:mb-4" /></h3>
                                        <p className="text-pink-600 font-bold text-sm sm:text-base">
                                            GEMISCHTE ABFÄLLE
                                        </p>
                                    </div>
                                </div>
                                <div className="flip-card-back bg-pink-600 p-4 sm:p-6 rounded-xl shadow-md">
                                    <div className="flex items-center justify-center h-full">
                                        <p className="text-white text-sm sm:text-base text-center">
                                            Verschiedene nicht sortierte Abfälle aus Haushalt und Gewerbe, die keiner speziellen Kategorie zugeordnet werden können.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link> */}
                    </div>
                </div>
            </section>

            {/* Containerübersicht */}
            <section id="container" className="py-12 sm:py-16 lg:py-24 bg-white">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-10 lg:mb-16">
                            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-pink-500 mb-4">Unsere Containergrößen</h2>
                            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">Finden Sie den passenden Container für Ihr Projekt</p>
                        </div>

                        {/* Absetzcontainer */}
                        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12 lg:mb-20">
                            {/* Text */}
                            <div className='bg-white shadow-xl rounded-xl p-6 sm:p-8 lg:p-10 hover:shadow-2xl transition-shadow duration-300'>
                                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 lg:mb-6">
                                    Absetzcontainer
                                </h2>
                                <div className="space-y-3 lg:space-y-4 text-base sm:text-lg text-gray-600">
                                    <p className="leading-relaxed">
                                        bis 7m³ Fassungsvermögen mit verschließbaren Klappen
                                    </p>
                                    <p className="leading-relaxed">
                                        bis 10 m³, sowohl abdeckbar als auch ohne Abdeckung.
                                    </p>
                                    <p className="leading-relaxed">
                                        trapezförmig ca 3,60m x 1,40m
                                    </p>
                                    <p className="leading-relaxed">
                                        Platzbedarf: ca 12m in der Länge und 3m in der Breite
                                    </p>
                                    <button className="mt-4 lg:mt-6 bg-pink-600 text-white px-6 py-3 rounded-lg hover:bg-pink-700 transition duration-200 font-medium text-sm sm:text-base shadow-md hover:shadow-lg">
                                        <a href="https://hirsch-group.de/containergroessen-und-containerarten">für mehr Informationen hier klicken</a>
                                    </button>
                                </div>
                            </div>

                            {/* Image */}
                            <div className="">
                                <img src='/images/Absetzcontainer_Hirsch.png' alt='Absetzcontainer Hirsch' className='w-full h-auto mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300' />
                            </div>
                        </div>

                        {/* Abrollcontainer */}
                        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12 lg:mb-20">
                            {/* Text */}
                            <div className='bg-white shadow-xl rounded-xl p-6 sm:p-8 lg:p-10 hover:shadow-2xl transition-shadow duration-300'>
                                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 lg:mb-6">
                                    Abrollcontainer
                                </h2>
                                <div className="space-y-3 lg:space-y-4 text-base sm:text-lg text-gray-600">
                                    <p className="leading-relaxed">
                                        mit 10 bis 36 m³ Fassungsvermögen
                                    </p>
                                    <p className="leading-relaxed">
                                        Höhe: zwischen 90 cm und 240 cm erhältlich (oben offen)
                                    </p>
                                    <p className="leading-relaxed">
                                        Breite: 240 cm
                                    </p>
                                    <p className="leading-relaxed">
                                        Länge: 650 cm
                                    </p>
                                    <p className="leading-relaxed">
                                        Platzbedarf: ca. 16 m Länge und 3 m Breite
                                    </p>
                                    <button className="mt-4 lg:mt-6 bg-pink-600 text-white px-6 py-3 rounded-lg hover:bg-pink-700 transition duration-200 font-medium text-sm sm:text-base shadow-md hover:shadow-lg">
                                        <a href="https://hirsch-group.de/containergroessen-und-containerarten">für mehr Informationen hier klicken</a>
                                    </button>
                                </div>
                            </div>

                            {/* Image */}
                            <div>
                                <img src='/images/hirsch 007_HoehereAufloesunguWeiterebeiThellmann.png' alt='Abrollcontainer Hirsch' className='w-full h-auto mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300' />
                            </div>
                        </div>

                        {/* Big Bag */}
                        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12 lg:mb-20">
                            {/* Text */}
                            <div className='bg-white shadow-xl rounded-xl p-6 sm:p-8 lg:p-10 hover:shadow-2xl transition-shadow duration-300'>
                                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 lg:mb-6">
                                    Big Bag
                                </h2>
                                <div className="space-y-3 lg:space-y-4 text-base sm:text-lg text-gray-600">
                                    <p className="leading-relaxed">
                                        bis 1 m³ Fassungsvermögen, 1 m² Grundfläche und ca. 2 m² Platzbedarf
                                    </p>
                                    <p className="leading-relaxed">
                                        Höhe: 110 cm
                                    </p>
                                    <p className="leading-relaxed">
                                        Breite: 90 cm
                                    </p>
                                    <p className="leading-relaxed">
                                        Länge: 90 cm
                                    </p>
                                    <button className="mt-4 lg:mt-6 bg-pink-600 text-white px-6 py-3 rounded-lg hover:bg-pink-700 transition duration-200 font-medium text-sm sm:text-base shadow-md hover:shadow-lg">
                                        <a href="https://hirsch-group.de/containergroessen-und-containerarten">für mehr Informationen hier klicken</a>
                                    </button>
                                </div>
                            </div>

                            {/* Image */}
                            <div>
                                <img src='/images/BIG BAG_NEU.png' alt='Big Bag Hirsch' className='w-full h-auto mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300' />
                            </div>
                        </div>




                    </div>
                </div>
            </section>

            {/* Fragen */}
            <section id="faq" className="py-12 sm:py-16 lg:py-24 bg-gradient-to-b from-gray-50 to-white">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-10 lg:mb-16">
                            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-pink-500 mb-4 lg:mb-6">
                                SIE HABEN FRAGEN?
                            </h2>
                            <p className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl text-gray-600 max-w-4xl mx-auto font-light">
                                Unser Team hilft Ihnen gerne weiter!
                            </p>
                        </div>

                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-8 lg:mt-12">
                            {teamMembers.map((member, index) => (
                                <div
                                    key={member.alt}
                                    className={`transform hover:scale-105 transition-transform duration-300 ${index === 2 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
                                >
                                    <div className="mx-auto w-48 h-48 sm:w-56 sm:h-56 lg:w-64 lg:h-64 rounded-full overflow-hidden shadow-xl bg-gray-100">
                                        <img
                                            src={member.image}
                                            alt={member.alt}
                                            className={`w-full h-full object-cover ${member.positionClass} ${member.zoomClass}`}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="text-center mt-8 lg:mt-12">
                            <div className="bg-pink-50 inline-block px-6 py-4 lg:px-8 lg:py-6 rounded-xl shadow-md">
                                <h2 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-pink-600 mb-2">
                                    container@hirsch-gmbh.com
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* Footer */}
            <footer id="footer" className="bg-gray-100 text-gray-700 relative" >
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 max-w-6xl mx-auto">
                        {/* UNTERNEHMEN */}
                        <div>
                            <h3 className="text-sm font-bold mb-4 text-gray-500 uppercase tracking-wider">UNTERNEHMEN</h3>
                            <ul className="space-y-2 text-sm text-gray-600">
                                <a href="https://hirsch-group.de/barrierefreiheitserklaerung"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Barrierefreiheitserklärung</span></li></a>
                                <a href="https://hirsch-group.de/widerrufsbelehrung"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Widerrufsbelehrung</span></li></a>
                                <a href="https://hirsch-group.de/datenschutz"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Datenschutz</span></li></a>
                                <a href="https://hirsch-group.de/kontakt"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Kontakt</span></li></a>
                                <a href="https://hirsch-group.de/impressum"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Impressum</span></li></a>
                                <a href="https://hirsch-group.de/agb"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">AGB</span></li></a>
                            </ul>
                        </div>

                        {/* ÖFFNUNGSZEITEN */}
                        <div>
                            <h3 className="text-sm font-bold mb-4 text-gray-500 uppercase tracking-wider">ÖFFNUNGSZEITEN</h3>
                            <ul className="space-y-2 text-sm text-gray-600">
                                <li className="flex justify-between">
                                    <span>Montag</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Dienstag</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Mittwoch</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Donnerstag</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Freitag</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between font-semibold">
                                    <span>Samstag</span>
                                    <span>GESCHLOSSEN</span>
                                </li>
                                <li className="flex justify-between font-semibold">
                                    <span>Sonntag</span>
                                    <span>GESCHLOSSEN</span>
                                </li>
                            </ul>
                        </div>

                        {/* KONTAKT */}
                        <div>
                            <div className="mb-6">
                                <img src={Logo} alt="Hirsch Logo" className="h-12 mb-6" />
                            </div>
                            <div className="space-y-3 text-sm text-gray-600">
                                <div className="flex items-start gap-2">
                                    <svg className="w-5 h-5 text-pink-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                    </svg>
                                    <span>+49 (0) 421 - 25802 - 580</span>
                                </div>
                                <div className="flex items-start gap-2">
                                    <svg className="w-5 h-5 text-pink-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    <span>container@hirsch-gmbh.com</span>
                                </div>
                                <div className="flex items-start gap-2">
                                    <svg className="w-5 h-5 text-pink-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                    </svg>
                                    <span>Hermann-Funk-Straße 6-9, 28309 Bremen</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bremen Skyline Section */}
                <div className="relative" >


                    {/* Pink Background Section with Copyright */}
                    <div className="bg-pink-600 text-white py-4">
                        <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
                            <p className="text-sm">© All rights reserved</p>

                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}